var map = {
	"./icons/favicon-32x32.png": 462,
	"./icons/icon-delete.svg": 343,
	"./icons/icon-edit.svg": 423,
	"./icons/icon-minus.svg": 488,
	"./icons/icon-plus.svg": 58,
	"./icons/icon-reply.svg": 992,
	"./images/image-amyrobson.png": 533,
	"./images/image-amyrobson.webp": 438,
	"./images/image-juliusomo.png": 420,
	"./images/image-juliusomo.webp": 287,
	"./images/image-maxblagun.png": 353,
	"./images/image-maxblagun.webp": 523,
	"./images/image-ramsesmiron.png": 718,
	"./images/image-ramsesmiron.webp": 100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;